import { render, staticRenderFns } from "./ComplieMindmapPlayModal.vue?vue&type=template&id=37a70f02&scoped=true"
import script from "./ComplieMindmapPlayModal.vue?vue&type=script&lang=js"
export * from "./ComplieMindmapPlayModal.vue?vue&type=script&lang=js"
import style0 from "./ComplieMindmapPlayModal.vue?vue&type=style&index=0&id=37a70f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a70f02",
  null
  
)

export default component.exports